import { Loader } from '../models';

export const LOADER_DEFAULTS: Loader.State = {
  progress: false,
};
